<template>
  <model-form
    :model="signageMediaItem"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-gutter-md items-start">
        <q-input
          v-model="signageMediaItem.name"
          class="col"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          autofocus
        />
        <q-input
          v-model="signageMediaItem.description"
          class="col"
          label="Description"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        />
        <q-checkbox
          v-model="signageMediaItem.enabled"
          label="Enabled"
          class="col-3"
        />
      </div>
      <div class="row q-col-gutter-md items-start">
        <q-select
          v-model="signageMediaItem.signageMediaClass"
          class="col"
          label="Media Class"
          option-value="id"
          option-label="name"
          map-options
          :options="signageMediaClasses.data"
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
        />
      </div>
      <div class="row q-col-gutter-md items-start">
        <q-input
          v-model="signageMediaItem.footerText"
          class="col"
          type="text"
          label="Footer Text"
          bottom-slots
          autogrow
        >
          <q-tooltip>
            This text will display above the footer on the signage.
          </q-tooltip>
        </q-input>
      </div>
      <div class="row q-col-gutter-md items-start">
        <q-toggle
          v-model="signageMediaItem.hasLink"
          class="col-6"
          label="Has Link"
        />
        <template v-if="signageMediaItem.hasLink">
          <q-input
            v-if="signageMediaItem.hasLink"
            v-model="signageMediaItem.buttonText"
            class="col-6"
            label="Button Text"
            :rules="[val => !!val || 'Field is required']"
            bottom-slots
          />
          <q-select
            v-model="signageMediaItem.movieId"
            input-style="inputStyle"
            :options="allMovies"
            option-label="name"
            option-value="id"
            class="col-12"
            label="Navigate to Movie"
            :rules="[val => !!val || 'Field is required']"
            map-options
            emit-value
          />
        </template>
      </div>
      <div
        v-if="signageMediaItem.mediaFormat === MEDIA_FORMAT.IMAGE"
        class="row q-col-gutter-md items-start"
      >
        <q-input
          v-model="signageMediaItem.displayDuration"
          type="number"
          class="col-5"
          label="Display Duration (Seconds)"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        />
      </div>
      <div v-if="signageMediaItem.mediaFormat !== MEDIA_FORMAT.VIDEO || !signageMediaItem.media">
        <div class="row text-h5 q-mt-lg">
          Image
        </div>
        <div class="row items-start q-col-gutter-lg">
          <image-uploader
            v-model="signageMediaItem.media"
            class="col-5"
            :image-url="signageMediaItem.mediaUrl"
            :model="signageMediaItem"
            @loading="(value) => dataUploading(MEDIA_FORMAT.IMAGE, value)"
          />
        </div>
        <q-input
          v-if="!signageMediaItem.media"
          v-model="signageMediaItem.media"
          :rules="[val => !!val || 'At least one media type must be present']"
          readonly
          :outlined="false"
          borderless
          style="height: 10px"
        />
      </div>
      <div v-if="signageMediaItem.mediaFormat !== MEDIA_FORMAT.IMAGE || !signageMediaItem.media">
        <div class="row text-h5 q-mt-lg">
          Video
        </div>
        <div class="row items-start q-col-gutter-lg">
          <video-uploader
            v-model="signageMediaItem.media"
            class="col-5"
            video-url-property="mediaUrl"
            :model="signageMediaItem"
            @loading="(value) => dataUploading(MEDIA_FORMAT.VIDEO, value)"
          />
        </div>
        <q-input
          v-if="!signageMediaItem.media"
          v-model="signageMediaItem.media"
          :rules="[val => !!val || 'At least one media type must be present']"
          readonly
          :outlined="false"
          borderless
          style="height: 10px"
        />
      </div>
    </div>
  </model-form>
</template>
<script>
import { MEDIA_FORMAT } from 'src/models/signage/SignageMediaItem'
import ImageUploader from 'src/modules/admin/components/ImageUploader'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import VideoUploader from 'src/modules/admin/components/VideoUploader'

export default {
  name: 'SignageMediaForm',
  components: {
    ModelForm,
    ImageUploader,
    VideoUploader
  },
  data () {
    return {
      loading: false,
      urlValidationMessage: null
    }
  },
  computed: {
    allMovies () {
      return [{ name: this.movies.loading ? `${this.$i18n.t('status.loading')}...` : this.$i18n.t('movie.actions.select'), value: null, disable: true }, ...(this.movies?.data || [])]
    }
  },
  created () {
    _.extend(this, { MEDIA_FORMAT })
  },
  async mounted () {
    this.signageMediaClasses.fetch(true)
  },
  models: {
    signageMediaItem: {
      signageMediaClass: 'default'
    },
    signageMediaClasses: {
      variables () {
        return {
          limit: 50
        }
      }
    },
    movies: {
      showingBadges: true,
      variables () {
        return {
          type: 'all-published',
          orderBy: 'magic',
          limit: 1000
        }
      }
    }
  },
  methods: {
    dataUploading (type, loadingValue) {
      this.loading = loadingValue
      if (type === 'video') {
        this.signageMediaItem.mediaFormat = MEDIA_FORMAT.VIDEO
      } else {
        this.signageMediaItem.mediaFormat = MEDIA_FORMAT.IMAGE
      }
    }
  }
}

</script>
